import { createAction } from '@reduxjs/toolkit'

export const setApprovalCache = createAction<{
  address: string
  chainId: number
  tokenAddress: string
  spender: string
  cache: boolean
}>('approvalCache/setApprovalCache')
